"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_error_message_1 = require("@hotelplan/components.common.error-message");
const libs_validation_1 = require("@hotelplan/libs.validation");
const SelectInput_1 = __importDefault(require("./SelectInput"));
const StatusSelectInput = (0, styled_components_1.default)(SelectInput_1.default)(({ success, theme }) => (success ? theme.inputs.success : {}), ({ error, theme }) => (error ? theme.inputs.error : {}));
const ValidatedSelectInput = props => {
    const [field, meta] = (0, formik_1.useField)({ name: props.name });
    const [t] = (0, next_i18next_1.useTranslation)();
    const inputState = (0, libs_validation_1.getValidatedFieldState)(meta.error, meta.touched);
    let icon = props.icon;
    switch (inputState) {
        case libs_validation_1.FieldState.Error:
            icon = { name: 'warning-outlined' };
            break;
        case libs_validation_1.FieldState.Success:
            icon = { name: 'success' };
            break;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StatusSelectInput, Object.assign({}, props, { success: inputState === libs_validation_1.FieldState.Success, error: inputState === libs_validation_1.FieldState.Error, value: field.value, onChange: (next, e) => field.onChange(e), onBlur: (e) => {
                field.onBlur(e);
            }, icon: icon })),
        props.showErrorMessage && inputState === libs_validation_1.FieldState.Error && (react_1.default.createElement(components_common_error_message_1.ErrorMessage, { getMessage: message => t(message), error: meta.error }))));
};
exports.default = ValidatedSelectInput;
//# sourceMappingURL=ValidatedSelectInput.js.map